import styled, { css } from 'styled-components';

export const PriceWrapper = styled.div`
  flex: 1;
  padding-top: 7px;

  .amount {
    font-weight: bold;
    white-space: nowrap;
  }

  .name-period {
    white-space: nowrap;
  }

  ${({ status, theme }) => {
    if (status === 'archived') {
      return css`
        text-decoration-line: line-through;
        color: ${theme.colors.color_darkgray};
      `;
    }
    return null;
  }}

  @media (max-width: 512px) {
    text-align: left;
    margin-left: 0px;
    padding-top: 7px;
    font-size: ${({ theme }) => theme.fontSize.sm};
    display: flex;
    justify-content: space-between;
  }
`;
